export enum ResponseStatus {
    ACCESSIBLE = 1,
    ERROR = 2,
    NOT_ACCESSIBLE = 3,
    NOT_AVAILABLE = 4
}

export interface Modalable {

    getStatus(): ResponseStatus;

    getModalId(): string;

    canBypassCheck(): boolean;
}
